import { list_all_auditlogs_v1 } from "@/graphql/queries";
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const GetAllListAuditLogs = {
  data: () => ({
    ListAllAuditLogs: [],
  }),
  methods: {
    async GetAllListAuditLogsMethod(organization_id) {
      try {
        let result = await client.graphql({
          query: list_all_auditlogs_v1,
          variables: {
            input: {
              limit: 100,
              nextToken: null,
              organization_id: organization_id,
              audit_type: this.selected_app_filter,
              from_date: this.formatedFromDate,
              to_date: this.formatedToDate,
              source: this.selected_source_status,
            },
          },
        });
        console.log("result", result);
        let ResultObj = JSON.parse(result.data.list_all_auditlogs_v1);
        if (ResultObj.Status === "SUCCESS") {
          this.ListAllAuditLogs = ResultObj.data;
        }
      } catch (error) {
        this.ListAllAuditLogs = [];
        console.log("Error", error);
      }
    },
  },
};
